export default "__VITE_ASSET__phs06osO__"